var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DataProfileRequest_1;
import { JSON, JsonDiscriminatorProperty, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var DataProfileRequestType;
(function (DataProfileRequestType) {
    DataProfileRequestType["CalcDataProfile"] = "calc_data_profile";
    DataProfileRequestType["RunDataProfile"] = "run_data_profile";
    DataProfileRequestType["DataSourceDataProfile"] = "data_source_data_profile";
    DataProfileRequestType["SampleDataProfile"] = "sample_data_profile";
})(DataProfileRequestType || (DataProfileRequestType = {}));
export var DataProfileErrorCodes;
(function (DataProfileErrorCodes) {
    DataProfileErrorCodes["RandomSampleNotExists"] = "dataProfile.randomSampleNotExists";
})(DataProfileErrorCodes || (DataProfileErrorCodes = {}));
const schema = {
    $id: 'urn:wisepipe-common-computation:DataProfileRequest',
    type: 'object',
    properties: {
        requestType: {
            type: 'string',
            enum: Object.values(DataProfileRequestType)
        },
        pipeID: { type: 'string', uid: 10 },
        runID: { type: 'string', uid: 9 },
        dataSourceID: { type: 'string', uid: 9 },
        multiColumnMode: { type: 'boolean' },
        page: { type: 'number', minimum: 1 },
        comparisonColumns: { type: 'array', items: { type: 'string' }, minItems: 2, maxItems: 2 },
        correlationColumns: { type: 'array', items: { type: 'string' } }
    },
    // if multiColumnMode is false then page is required
    if: { properties: { multiColumnMode: { const: true } } },
    then: { required: [] },
    else: { required: ['page'] },
    required: ['requestType', 'multiColumnMode'],
    anyOf: [{ required: ['pipeID'] }, { required: ['runID'] }, { required: ['dataSourceID'] }]
};
let DataProfileRequest = DataProfileRequest_1 = class DataProfileRequest {
    constructor(requestType, pipeID, runID, dataSourceID, multiColumnMode, page, comparisonColumns, correlationColumns) {
        this.requestType = requestType;
        this.pipeID = pipeID;
        this.runID = runID;
        this.dataSourceID = dataSourceID;
        this.multiColumnMode = multiColumnMode;
        this.page = page;
        this.comparisonColumns = comparisonColumns;
        this.correlationColumns = correlationColumns;
        JSON.validate(this, DataProfileRequest_1);
    }
    get pyJobRoute() {
        return this.pipeID || this.runID || this.dataSourceID;
    }
};
DataProfileRequest = DataProfileRequest_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorProperty('requestType')
], DataProfileRequest);
export { DataProfileRequest };
//# sourceMappingURL=dataProfileRequest.js.map